import { useEffect, useRef } from 'react';

import LoadScreen from '../../components/Cards/LoadScreen';
import useOnRefreshScreen from '../../hooks/auth/useOnRefreshScreen';
import useDashboardLoading from '../../hooks/dashboard/dashboardLoading/useDashboardLoading';
import { useAppSelector } from '../../redux/store';
import DashboardLayoutOutlet from './DashboardLayoutOutlet';

const DashboardLayout = () => {
  const { onRefreshScreen, loading } = useOnRefreshScreen();
  const { getDashboardLoadingData, loading: dashboardDataLoading } =
    useDashboardLoading();
  const { authData } = useAppSelector((state) => state.auth);
  const hasFetchedData = useRef(false);

  useEffect(() => {
    onRefreshScreen();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (authData?.user?.id && !loading && !hasFetchedData.current) {
      hasFetchedData.current = true;
      getDashboardLoadingData();
    }
    // eslint-disable-next-line
  }, [authData?.user?.id, loading]);

  if (loading || dashboardDataLoading || !authData) {
    return <LoadScreen />;
  }

  return <DashboardLayoutOutlet />;
};

export default DashboardLayout;
